

// Polyfills (mostly for IE/Edge)
$(function () {
  const tip = tippy(document.querySelectorAll('.tippy'));

  tippy.browser.onUserInputChange = function (type) {
    const method = type === 'touch' ? 'disable' : 'enable'
    for (const tooltip of tip.tooltips) {
      tooltip[method]()
    }
  }

  var current_location = window.location.pathname;

  function initPage(location){
    if(location !== '/nous-contacter'){
      $('.wait-page__cards').addClass('animated');
    } else {
      $('.wait-page__bottom').addClass('form-open');
      $('.contact-form').css('-webkit-transition-delay', '0s' )
     .css('-moz-transition-delay', '0s')
     .css('-ms-transition-delay', '0s')
     .css('-o-transition-delay', '0s')
     .css('transition-delay', '0s');
    }
  }

  initPage(current_location);
  svg4everybody(); // External SVG
});

function changeLocation(url, current_location){
  var stateObj = { currentLocation: current_location };
  history.pushState(stateObj, "page 2", url);
}

$('.wait-card, .wait-page__header__logo, .wait-page__header__contact, .wait-page__header__close-contact').click(function(event){
  event.preventDefault();
  event.stopPropagation();

  var section = $(this).attr('data-section');
  var url = $(this).attr('data-url');

  changeLocation(url);

  $('body').removeClass (function (index, css) {
    return (css.match (/(^|\s)section--\S+/g) || []).join(' ');
  });

  $('body').addClass('section--'+section);

  $('.wait-page__bottom').removeClass('form-open');
  $('.wait-page__cards').addClass('animated');

});


$('.wait-page__header__contact').click(function(){
    $('.wait-page__cards').toggleClass('animated');
    $('.wait-page__bottom').toggleClass('form-open');
});


$('.content__click-caption').hover(function(){
  $('.wait-page__cards').addClass('hovered');
});

$('.content__click-caption').mouseleave(function(){
  $('.wait-page__cards').removeClass('hovered');
});

$('#contact-form-post').submit(function(event){
  event.preventDefault();
  $('.contact-form__send-button-container').addClass('sending');

  changeLocation('/');

  $.ajax({
    type: "POST",
    url: '/contact',
    data: $(this).serialize(),
    success: function(){
      $('.wait-page__bottom').removeClass('form-open');
      $('.wait-page__cards').addClass('animated');

      $('body').removeClass (function (index, css) {
        return (css.match (/(^|\s)section--\S+/g) || []).join(' ');
      });

      $('body').addClass('section--default');

      $('#nom, #prenom, #objet, #email, #message').val('');
      $('.contact-form__send-button-container').removeClass('sending');
    }
  });
});
